import { Box, Image, Inline, Stack, Text, Link, Styled } from '@front10/base-elements';
import * as React from 'react';
import { useTranslation } from '@front10/utils';

interface Props {
  title: string;
  componentName?: string;
  contactEmail?: string;
}

export function ContactPanel({
  title,
  sx,
  componentName = 'premium-experience-grid',
  contactEmail = 'premiumexperiences@tennis.com.au'
}: React.PropsWithChildren<Styled<Props>>) {
  const translate = useTranslation();
  return (
    <Box
      sx={{
        isolation: 'isolate',
        maxHeight: '100vh',
        overflow: 'auto',
        ...sx
      }}
    >
      <Inline
        sx={{
          position: 'relative',
          bg: 'accent'
        }}
      >
        <Image
          src="https://res.cloudinary.com/dakp804eh/image/upload/v1631133252/airmodules/Utils/ausopen/bg-contact.svg"
          alt=""
          height="132"
          width="252"
          sx={{ objectFit: 'cover', height: '132px' }}
        />
        <Inline alignY="center" align="center" sx={{ flex: '1 0 auto' }}>
          <Text
            variant="fontSize2"
            as="h2"
            sx={{ textAlign: 'center', color: 'backgroundMain', paddingX: '20px' }}
          >
            {translate(`cmp-${componentName}-contact-us-popup-title`, 'Contact Us')}
          </Text>
        </Inline>
      </Inline>
      <Stack
        pt="28px"
        px="32px"
        pb="38px"
        gap="3"
        alignY="space-between"
        variant="text.fontSize5"
        sx={{ height: '100%' }}
      >
        <Text variant="heading2" as="h3">
          {title}
        </Text>
        <p>
          {translate(`cmp-${componentName}-left-email-text`, 'Please submit your inquiry to')}{' '}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>{' '}
          {translate(`cmp-${componentName}-right-email-text`, 'with your:')}
        </p>
        <ul style={{ height: '100%' }}>
          <li>{translate(`cmp-${componentName}-contact-us-popup-name-label`, 'Name')}</li>
          <li>{translate(`cmp-${componentName}-contact-us-popup-phone-label`, 'Phone number')}</li>
          <li>
            {translate(
              `cmp-${componentName}-contact-us-popup-number-people`,
              'Number of people you are booking for '
            )}
          </li>
          <li>
            {translate(
              `cmp-${componentName}-contact-us-popup-session`,
              'Session preference if any'
            )}
          </li>
        </ul>
      </Stack>
      <Inline alignY="end" sx={{ bg: 'aoTangerine', height: '44px', pb: '9px', px: '20px' }}>
        <Image
          src="https://res.cloudinary.com/dakp804eh/image/upload/v1631555874/airmodules/Utils/ausopen/brand-icon-inverted-sm.svg"
          alt=""
        />
      </Inline>
    </Box>
  );
}
